import orderInstance from '../instance'

const confirmOrderPayments = (orderId, data) => {
  return orderInstance.post('/orders/' + orderId + '/payments/confirm', data)
}

export default confirmOrderPayments
